import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_TIMETABLE_SAGA } from "../sagaTypes";
import { loadingAction, setScheduleAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";

const request = data => {
    return fetch(`${ url }/get_timetable`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetTimetable(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);
    const schedule = yield select(state => state.schedule);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('establishment', est.id);
        formData.append('date', args.data?.date || schedule.date);
        formData.append('master', schedule.selected_master);
        formData.append('services', JSON.stringify(schedule.selected_services));

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setScheduleAction({
                ...schedule,
                open: true,
                stage: response.data.stage,
                date: response.data.date,
                times: response.data.times
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetTimetable() {
    yield takeLatest(GET_TIMETABLE_SAGA, workerGetTimetable);
}